import React from "react"
import dateformat from "dateformat"
import {DEFAULT} from "../../../constants/design/SkinTypes"
import SkinCardTags from "./SkinCardTags"

function DefaultSkinDesc({skin, onSelect, onChangeFilter}) {
  return (
    <div className="desc_skin">
      <strong className="tit_skin">
        <a className="txt_ellip" onClick={() => onSelect(skin)}>
          {skin.title}
        </a>
      </strong>

      <SkinCardTags skin={skin} onChangeFilter={onChangeFilter} />
    </div>
  )
}

function ArchiveSkinDesc({skin, onSelect}) {
  return (
    <div className="desc_skin">
      <strong className="tit_skin">
        <a className="txt_ellip" onClick={() => onSelect(skin)}>
          {skin.archiveName}
        </a>
      </strong>

      <div className='bundle_tag'>
        <span className='txt_info'>{dateformat(new Date(skin.savedDate * 1000), 'yyyy-mm-dd HH:MM')}</span>
      </div>
    </div>
  )
}

export default function SkinCardDesc({skin, type, onSelect, onChangeFilter}) {
  if (type === DEFAULT) {
    return <DefaultSkinDesc skin={skin} onSelect={onSelect} onChangeFilter={onChangeFilter} />
  } else {
    return <ArchiveSkinDesc skin={skin} onSelect={onSelect} />
  }
}
